module.exports = __webpack_public_path__ + "static/appgallery-badge-tr-ed86099a9b239844a0ebd75412648e3d.svg";